import { PaymentApi } from '@linktivity/ars-neo';
import config from './config';

const paymentApi = new PaymentApi(config);

export default paymentApi;
